import Alert from '@mui/material/Alert';
import Button from '@mui/material/Button';

interface Props {
    message: string | null;
    retryLabel?: string;
    onRetry?: () => void;
    retrying: boolean;
}

export function JiraRetryBanner({ message, retryLabel, onRetry, retrying }: Props) {
    if (!message) {
        return null;
    }

    return (
        <Alert
            severity="warning"
            data-testid="jira-retry-banner"
            sx={{ mb: 2 }}
            action={
                onRetry ? (
                    <Button color="inherit" size="small" disabled={retrying} onClick={onRetry} data-testid="jira-retry-banner-retry">
                        {retryLabel}
                    </Button>
                ) : undefined
            }
        >
            {message}
        </Alert>
    );
}
